import { apiFetcher } from '@/config/api-fetcher.config';
import type { GetProjects } from '@/server/api/rest/project/project-repository.ssr';
import {
  isJsonApiSuccessResponse,
  type JsonApiResponse,
} from '@httpx/json-api';

export const fetchProjects = async (): Promise<GetProjects> => {
  try {
    const resp =
      await apiFetcher<JsonApiResponse<GetProjects>>('/api/rest/project');

    if (!isJsonApiSuccessResponse(resp)) {
      const errors = 'errors' in resp ? resp.errors : '';
      console.error('API Response Error:', errors);
      throw new Error(`Error fetching projects: ${JSON.stringify(errors)}`);
    }

    return resp.data;
  } catch (error) {
    console.error('Fetch Projects Error:', error);
    if (error instanceof Error) {
      throw new TypeError(`Failed to fetch projects: ${error.message}`, {
        cause: error,
      });
    }
    throw new Error('An unexpected error occurred while fetching projects', {
      cause: error,
    });
  }
};
